import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const teletracnavmanConfig: TSPConfig = {
  key: 'teletracnavman',
  name: 'Teletrac Navman',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please request an API key from your Teletrac Navman representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default teletracnavmanConfig;
